// Ticket 20: Lounge Session Tracking API
// Ticket 27: Lounge Gifting API

const API_BASE = window.location.origin;

export async function reportLoungeSession(sessionSeconds, roomId = null) {
  const token = localStorage.getItem('token');
  const res = await fetch(`${API_BASE}/api/lounge/track-session`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: token ? `Bearer ${token}` : '',
    },
    body: JSON.stringify({ session_seconds: sessionSeconds, room_id: roomId }),
  });
  
  if (!res.ok) {
    console.error('[Lounge] Failed to report session', await res.text());
  }
  
  return res.json();
}

// Ticket 27: Send a gift to another user in the lounge
export async function sendLoungeGift({ roomId, recipientId, giftKey }) {
  const token = localStorage.getItem('token');
  const res = await fetch(`${API_BASE}/api/lounge/gifts/send`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: token ? `Bearer ${token}` : '',
    },
    body: JSON.stringify({
      to_user_id: recipientId,
      gift_key: giftKey,
      room_id: roomId,
    }),
  });
  
  if (!res.ok) {
    const errorData = await res.json().catch(() => ({}));
    const error = new Error(errorData.detail?.message || errorData.detail || 'Failed to send gift');
    error.code = errorData.detail?.code;
    error.balance = errorData.detail?.balance;
    error.required = errorData.detail?.required;
    throw error;
  }
  
  return res.json();
}
